import { Dispatch, RefObject, SetStateAction, useEffect } from 'react';

import { INITIAL_AUDIO_STATE } from '@/components/emotion-detector/AudioPlayer/constants';
import { CurrentAudio } from '@/components/emotion-detector/AudioPlayer/types';

interface UseAudioCleanupProps {
	audioRef: RefObject<HTMLAudioElement | null>;
	currentAudio: CurrentAudio;
	setCurrentAudio: Dispatch<SetStateAction<CurrentAudio>>;
}

/**
 * Cleans up audio playback on component unmount and before page navigation
 */
export function useAudioCleanup({ audioRef, currentAudio, setCurrentAudio }: UseAudioCleanupProps) {
	useEffect(() => {
		const stopAllAudio = () => {
			if (audioRef.current) {
				audioRef.current.pause();
				audioRef.current.currentTime = 0;
			}

			if (currentAudio.element) {
				currentAudio.element.pause();
				currentAudio.element.currentTime = 0;
				setCurrentAudio(INITIAL_AUDIO_STATE);
			}

			document.querySelectorAll('audio').forEach(audio => {
				audio.pause();
				audio.currentTime = 0;
			});
		};

		const handleBeforeUnload = () => {
			stopAllAudio();
		};

		window.addEventListener('beforeunload', handleBeforeUnload);

		return () => {
			stopAllAudio();
			window.removeEventListener('beforeunload', handleBeforeUnload);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [setCurrentAudio, currentAudio.element]);
}
